import Vue from 'vue'
import Router from 'vue-router'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const DashbardInstituteResults = () => import('@/views/dashboards/institute_results')
const DashboardRemainingBudgets = () => import('@/views/dashboards/remaining_budgets')
const ProjectsAGPData = () => import('@/views/projects/agp_data')
const ProjectsAccountingData = () => import('@/views/projects/accounting_data')
const ProjectsMandateData = () => import('@/views/projects/mandate_data')
const ProjectsAutofunding = () => import('@/views/projects/autofunding')
const ProjectsLossProvisions = () => import('@/views/projects/project_loss_provisions')
const ProjectsFees = () => import('@/views/projects/management_fees')
const StaffSalariesFdt = () => import('@/views/staff/salaries_fdt')
const StaffAssignedRates = () => import('@/views/staff/assigned_rates')
const StaffHourlyRates = () => import('@/views/staff/hourly_rates')
const AnomalyMissingInitials = () => import('@/views/anomalies/missing_initials')
const AnomalyOverrunsP5 = () => import('@/views/anomalies/cost_overruns_pilier_5')

// Views - Pages
const Page403 = () => import('@/views/pages/Page403')
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')

Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard/institute-results',
      name: 'TBFI',
      component: TheContainer,
      //beforeEnter(to, from, next) {
      //  if (!store.getters.isAuthenticated) {
      //    next('/login')
      //  } else {
      //    next()
      //  }
      //},
      children: [
        {
          path: 'dashboard/institute-results',
          name: 'Résultat de l\'institut',
          component: DashbardInstituteResults
        },
        {
          path: 'dashboard/remaining-budgets',
          name: 'Soldes disponibles',
          component: DashboardRemainingBudgets
        },
        {
          path: 'projects/agp-data',
          name: 'Projets vue AGP',
          component: ProjectsAGPData
        },
        {
          path: 'projects/accounting-data',
          name: 'Projets vue comptable',
          component: ProjectsAccountingData
        },
        {
          path: 'projects/mandate-data',
          name: 'Mandats',
          component: ProjectsMandateData
        },
        {
          path: 'projects/autofunding',
          name: 'Autofinancement',
          component: ProjectsAutofunding
        },
        {
          path: 'projects/lossprovisions',
          name: 'Provisions de risque',
          component: ProjectsLossProvisions
        },
        {
          path: 'projects/fees',
          name: 'Frais de gestions',
          component: ProjectsFees
        },
        {
          path: 'staff/salaries-fdt',
          name: 'Salaires fonds de tiers',
          component: StaffSalariesFdt
        },
        {
          path: 'staff/assigned-rates',
          name: 'Taux d\'affectation',
          component: StaffAssignedRates
        },
        {
          path: 'staff/hourly-rates',
          name: 'Taux horaires',
          component: StaffHourlyRates
        },
        {
          path: 'anomalies/missing-initials',
          name: 'Chefs de projet sans initiales',
          component: AnomalyMissingInitials
        },
        {
          path: 'anomalies/overruns-p5',
          name: 'Dépassement de budget pilier 5',
          component: AnomalyOverrunsP5
        },
      ]
    },
    {
      path: '/login',
      name: 'Connexion',
      component: Login
    },
    {
      path: '/error',
      redirect: '/error/500',
      name: 'Erreur',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '403',
          name: 'Page403',
          component: Page403
        },
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        }
      ]
    }
  ]
})
